/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="30" height="30" viewBox="0 0 30 30" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <path d="M21,12.34A8.74,8.74,0,0,1,7.5,19.71a6,6,0,0,0,.73,0,6.22,6.22,0,0,0,3.83-1.31A3.1,3.1,0,0,1,9.18,16.3a2.78,2.78,0,0,0,.58.06,3.1,3.1,0,0,0,.81-.11,3.09,3.09,0,0,1-2.47-3v0a3.15,3.15,0,0,0,1.4.39,3.1,3.1,0,0,1-1-4.11,8.72,8.72,0,0,0,6.35,3.21,2.68,2.68,0,0,1-.08-.7,3.08,3.08,0,0,1,5.32-2.1,6.37,6.37,0,0,0,2-.75,3.11,3.11,0,0,1-1.36,1.7,6.09,6.09,0,0,0,1.77-.48A6,6,0,0,1,21,11.94C21,12.07,21,12.21,21,12.34ZM0,15A15,15,0,1,0,15,0,15,15,0,0,0,0,15Z" style={{fillRule: "evenodd"}} className="icon-fill"/>
</svg>
    )
  }
}

Icon.displayName = 'TwitterIcon'

export default Icon
